{
  "common": {
    "welcome": "欢迎",
    "login": "登录",
    "logout": "退出登录",
    "register": "注册账号",
    "forgotPassword": "忘记密码",
    "username": "用户名",
    "password": "密码",
    "confirmPassword": "确认密码",
    "inviteCode": "邀请码",
    "profile": "个人中心",
    "companyName": "沃亚基国际卡派专家",
    "prevStep": "上一步",
    "nextStep": "下一步",
    "submit": "提交",
    "add": "新增",
    "back": "返回",
    "cancel": "取消",
    "confirm": "确定",
    "processing": "处理中...",
    "saving": "保存中...",
    "save": "保存",
    "yes": "是",
    "no": "否",
    "pageSize": "每页显示",
    "total": "共",
    "itemsPerPage": "条/页",
    "updateSuccess": "修改成功",
    "updateFailed": "修改失败",
    "copyright": "Copyright © 贵阳沃亚基 2024",
    "warning": "警告",
    "deleteConfirm": "确定要删除吗？",
    "expand": "显示更多",
    "collapse": "收起",
    "qxz": "请选择",
    "loading": "加载中",
    "searchPlaceholder": "输入关键字查询",
    "search": "查询",
    "reset": "重置",
    "actions": "操作",
    "qsr": "请输入",
    "del": "批量删除",
    "selectDelete": "请选择需要删除的数据",
    "num": "序号",
    "error": "操作失败",
    "copyFailed": "复制失败",
    "userType": {
      "admin": "管理员",
      "normal": "普通用户",
      "customerService": "客服",
      "finance": "财务",
      "manager": "主管"
    },
    "noData": "暂无数据"
  },
  "menu": {
    "shipment": "在线测价",
    "orders": "订单列表",
    "profile": "个人中心",
    "customers": "我的客户",
    "guide": "平台指引",
    "addresses": "地址管理",
    "contact": "联系我们",
    "finance": "财务明细",
    "quoteHistory": "报价历史",
    "customerDetails": "客户详情",
    "customerList": "客户列表",
    "customersView": "客户管理",
    "orderDetails": "订单详情",
    "login": "登录",
    "menu": "菜单管理",
    "role": "角色管理",
    "invoice": "发票管理"
  },
  "login": {
    "title": "沃亚基国际卡派专家",
    "subtitle": "我们给您最优方案",
    "usernamePlaceholder": "用户名*",
    "passwordPlaceholder": "密码*",
    "emailPlaceholder": "邮箱地址*",
    "verificationCodePlaceholder": "验证码*",
    "sendCode": "发送验证码",
    "codeSent": "验证码已发送",
    "sendCodeFailed": "验证码发送失败",
    "emailInvalid": "请输入有效的邮箱地址",
    "loginType": {
      "password": "切换至密码登录",
      "email": "切换至邮箱登录"
    },
    "showPassword": "显示密码",
    "hidePassword": "隐藏密码",
    "loginButton": "登录",
    "loggingIn": "登录中...",
    "failed": "登录失败",
    "networkError": "网络错误，请稍后重试",
    "invalidCredentials": "用户名或密码错误",
    "verifyCodePlaceholder": "图形验证码*",
    "verifyCodeInvalid": "请输入正确的验证码",
    "verifyCodeTitle": "请输入图形验证码"
  },
  "forgotPassword": {
    "title": "忘记密码",
    "contact": "请通过以下方式联系我们：",
    "email": "电子邮件",
    "phone": "客服电话",
    "workingHours": "工作时间：周一至周五 9:00-18:00"
  },
  "register": {
    "usernamePlaceholder": "用户名*",
    "emailPlaceholder": "邮箱地址*",
    "verificationCodePlaceholder": "验证码*",
    "passwordPlaceholder": "密码* (8-20 个字符，需包含大写字母和数字)",
    "confirmPasswordPlaceholder": "确认密码* (请再次输入密码)",
    "inviteCodePlaceholder": "邀请码* (请输入邀请码)",
    "sendCode": "发送验证码",
    "codeSent": "验证码已发送",
    "sendCodeFailed": "验证码发送失败",
    "emailInvalid": "请输入有效的邮箱地址",
    "submitButton": "注册",
    "registering": "注册中...",
    "success": "注册成功",
    "failed": "注册失败",
    "usernameInvalid": "用户名必须为 4-20 个字符，只能包含字母、数字、下划线和横线",
    "passwordInvalid": "密码必须为 8-20 个字符，且包含至少一个大写字母、一个小写字母和一个数字",
    "passwordMismatch": "两次输入的密码不一致",
    "networkError": "网络错误，请稍后重试",
    "userPhonePlaceholder": "用户手机*",
    "userPhoneInvalid": "请输入正确的手机号"
  },
  "views": {
    "guide": {
      "title": "平台指引"
    },
    "quoteHistory": {
      "title": "报价历史",
      "quoteNumber": "报价单号",
      "createdAt": "创建时间",
      "origin": "起始地",
      "destination": "目的地",
      "cargo": "货物",
      "service": "服务",
      "price": "价格",
      "noQuotes": "暂无报价",
      "loading": "加载报价中..."
    },
    "addresses": {
      "title": "地址簿",
      "add": "添加地址",
      "searchPlaceholder": "搜索地址...",
      "form": {
        "companyNamePlaceholder": "请输入公司名称",
        "streetPlaceholder": "请输入街道地址",
        "cityPlaceholder": "请输入城市",
        "statePlaceholder": "请输入州/省",
        "zipPlaceholder": "请输入邮政编码",
        "zipValidation": "请输入正确的邮编",
        "countryPlaceholder": "请输入国家",
        "zipError": "请输入正确的邮编"
      },
      "list": {
        "title": "地址列表",
        "columns": {
          "companyName": "公司名称",
          "street": "街道",
          "city": "城市",
          "state": "州/省",
          "zip": "邮编",
          "country": "国家"
        },
        "selectAddressWarning": "请选择地址"
      },
      "fetchError": "获取地址列表失败",
      "createSuccess": "地址创建成功",
      "updateSuccess": "地址更新成功",
      "deleteSuccess": "地址删除成功",
      "saveError": "保存地址失败",
      "deleteError": "删除地址失败",
      "deleteConfirm": "确定要删除这个地址吗？",
      "noAddresses": "暂无地址",
      "invalidZip": "邮编无效或服务不可用"
    },
    "contact": {
      "title": "联系我们",
      "phone": "联系电话",
      "hotline": "充值热线",
      "email": "电子邮箱",
      "workingHours": "工作时间",
      "address": "联系地址",
      "bankAccount": "对公账户",
      "onlineSupport": "在线客服",
      "wechat": "微信公众号"
    },
    "shipment": {
      "title": "货运",
      "step1": "报价",
      "step2": "详情",
      "quoteNumber": "报价单号",
      "getNewQuote": "获取新的报价",
      "originInfo": "起始地信息",
      "destinationInfo": "目的地信息",
      "companyName": "公司名",
      "companyNamePlaceholder": "输公司名",
      "streetAddress": "街道地址",
      "streetAddressPlaceholder": "入街道地址",
      "city": "城市",
      "cityPlaceholder": "输入城市",
      "state": "州",
      "statePlaceholder": "输入州",
      "zip": "邮政编码",
      "zipPlaceholder": "输入邮政编码",
      "country": "国家",
      "pickupDate": "取货准备日期",
      "pickupTime": "取货准备时间",
      "pickupCloseDate": "取货截止日期",
      "pickupCloseTime": "取货截止时间",
      "airportPU": "机场取货",
      "appointment": "预约",
      "cfsPickup": "集装箱货运站取货",
      "constructionSite": "建筑工地",
      "hazardousMaterial": "危险品",
      "hospitalPickup": "医院取货",
      "insidePickup": "室内取货",
      "liftgate": "尾板服务",
      "limitedAccessPickup": "受限访问取货",
      "mineSitePickup": "矿场取货",
      "notification": "通知",
      "protectFromFreezing": "防冻保护",
      "residential": "住宅",
      "detailsInfo": "货运详情",
      "detailsComingSoon": "详细信息表单即将推出...",
      "airportDelivery": "机场配送",
      "churchDelivery": "教堂配送",
      "groceryWarehouse": "超市仓库",
      "limitedAccess": "限制地址配送",
      "overLength12": "超长 - 12-16 英尺",
      "overLength8": "超长 - 8-12 英尺",
      "additionalServices": "额外服务",
      "cfs": "集装箱货运站提货",
      "driverAssist": "司机协助",
      "insideDelivery": "室内配送",
      "lumperFee": "装卸费",
      "mineSiteDelivery": "矿场配送",
      "overLength16": "超长 - 16-20 英尺",
      "overLength20": "超长 - 20 英尺以上",
      "palletJack": "叉车",
      "residentialAppointment": "Forward Air 专属住宅预约",
      "sortAndSeg": "分类配送",
      "TradeShow": "展会派送",
      "commodityInfo": "货物信息",
      "handlingUnit": "打托数",
      "packageType": "托盘类型",
      "palletSizePreset": "托盘常规尺寸",
      "palletSizes": {
        "48x40": "托盘 (48×40)",
        "48x48": "托盘 (48×48)",
        "60x48": "托盘 (60×48)",
        "custom": "托盘 (自定义)"
      },
      "pieces": "件数",
      "description": "品名",
      "dimensions": "尺寸",
      "totalWeight": "总重量",
      "estimatedDimensions": "预估尺寸",
      "handlingUnitPlaceholder": "输入打托数",
      "descriptionPlaceholder": "输入以搜索已保存产品",
      "residentialPickup": "住宅提货",
      "residentialDelivery": "住宅区配送",
      "length": "长",
      "width": "宽",
      "height": "高",
      "class": "密度等级",
      "nmfc": "汽车货运分类",
      "linearFeet": "线性英尺",
      "generateSmartQuote": "获取智能报价",
      "pricingInformation": "价格信息",
      "carrier": "承运商",
      "transitTime": "预计运输时间",
      "maxLiability": "最大赔偿额度",
      "rate": "运费",
      "fsc": "燃油附加费",
      "accessorials": "额外服务费",
      "total": "总计",
      "quoteSpeed": "报价速度",
      "request": "响应",
      "guaranteedOnly": "零担报价",
      "volumeOnly": "仅限体积拼车",
      "saveQuote": "保存报价",
      "confirmSave": "确认保存",
      "cancelSave": "取消保存",
      "saveSuccess": "报价保存成功",
      "select": "选择",
      "pickupInfo": "提货信息",
      "deliveryInfo": "送货信息",
      "orderInfo": "订单信息",
      "selectQuoteFirst": "请先选择一个报价",
      "contactName": "联系人",
      "phone": "电话",
      "email": "电子邮箱",
      "pickupFacility": "提货设施",
      "deliveryFacility": "送货设施",
      "specialPickupInstructions": "特殊提货说明",
      "specialDeliveryInstructions": "特殊送货说明",
      "specialInstructionsPlaceholder": "在此输入任何特殊说明...",
      "business": "企业",
      "residence": "住宅",
      "construction": "建筑工地",
      "cityStateZip": "城市, 州 邮编",
      "selected": "已选择",
      "deliveryDate": "预计送达日期",
      "deliveryTime": "营业时间",
      "deliveryCloseTime": "停止营业时间",
      "customerPO": "客户订单号",
      "shipperReference": "发货参考号",
      "loadRelease": "装货放行号",
      "file": "文件",
      "temperature": "温度",
      "trackingReference": "跟踪参考号",
      "seal": "封号",
      "customReference": "自定义参考号",
      "packageTypes": {
        "AFrame": "A型框架",
        "Bags": "袋子",
        "Bales": "包件",
        "Barrel": "桶",
        "Basket": "篮子",
        "Batteries": "电池",
        "Bins": "箱柜",
        "Box": "箱子",
        "BreakBulk": "散装",
        "Bundle": "捆",
        "Cans": "罐",
        "Cart": "手推车",
        "Carton": "纸箱",
        "Case": "箱盒",
        "Chest": "柜子",
        "Container": "集装箱",
        "Crate": "木箱",
        "Cylinder": "圆筒",
        "Drum": "圆桶",
        "Gallons": "加仑",
        "Gaylords": "大型纸箱",
        "HalfPallets": "半托盘",
        "Hopper": "料斗",
        "Jerricans": "塑料桶",
        "LiftVan": "搬运车",
        "Loose": "散装",
        "Package": "包裹",
        "Pails": "桶",
        "Pallet": "托盘",
        "Piece": "件",
        "Racks": "货架",
        "Reel": "卷轴",
        "Roll": "卷",
        "Skid": "托架",
        "Stacks": "堆",
        "Totes": "手提箱",
        "Truckload": "整车",
        "Tube": "管",
        "Tubs": "浴盆",
        "UBox": "U型箱",
        "Unit": "单元",
        "Vehicle": "车辆",
        "Wheels": "轮子"
      },
      "pleaseComplete": "请填写以下信息",
      "submitSuccess": "货物运输提交成功",
      "submitError": "下单失败, 请尝试选择其他报价",
      "pleaseCompleteForm": "请填写所有必填信息",
      "generatingQuote": "正在获取报价...",
      "submittingToCarrier": "正在提交到承运商...",
      "selectAddress": "选择地址",
      "addressLoadError": "加载地址列表失败",
      "type": "类型",
      "warehouse": "仓库",
      "confirmSubmit": "确认提交",
      "confirmMessage": "请确认好运输信息，下单后取消需要联系客服",
      "insufficientBalance": "余额不足",
      "noQuotes": "暂无报价",
      "units": {
        "imperial": {
          "length": "长 (英寸)",
          "width": "宽 (英寸)",
          "height": "高 (英寸)",
          "weight": "总重量 (磅)",
          "unit": "英寸"
        },
        "metric": {
          "length": "长 (厘米)",
          "width": "宽 (厘米)",
          "height": "高 (厘米)",
          "weight": "总重量 (千克)",
          "unit": "厘米"
        },
        "switch": "切换单位"
      },
      "oversizedWarning": "货物属于超大件，会有额外收费",
      "addLineItem": "添加货物",
      "serviceLevel": "服务等级",
      "clearItemsFirst": "请先删除当前的货物信息",
      "totals": {
        "handlingUnits": "累计打托数",
        "pieces": "累计件数",
        "weight": "累计重量",
        "pcf": "总 PCF",
        "lf": "总线性英尺"
      },
      "availableQuotes": "可用报价",
      "lineHaul": "运输费",
      "fuelSurcharge": "燃油附加费",
      "totalPrice": "总价格",
      "poReference": "客户订单号",
      "pleaseSelectQuotes": "请选择报价",
      "saveFailed": "保存失败",
      "quoteError": "获取报价错误",
      "shipmentType": "运单类型",
      "dimensionUnits": "尺寸单位",
      "weightUnits": "重量单位",
      "createdAt": "创建于",
      "shipmentTypeText": "运输",
      "goodsCount": "件货物",
      "priceQuotes": "个报价",
      "viewDetails": "查看详情",
      "editOrder": "编辑订单",
      "goodsInfo": "货物信息",
      "priceInfo": "报价信息",
      "providerCode": "服务商",
      "hasStackable": "可叠放",
      "hazmatDesc": "危害类别",
      "hasHazmat": {
        "switch": "切换危险品"
      },
      "unNumber": "UN编号",
      "packingGroup": "包装组别",
      "dimensionsDesc": "长×宽×高",
      "invalidHandlingUnit": "物品打托数不能为0",
      "invalidDescription": "品名不能为空"
    },
    "orders": {
      "title": "历史订单",
      "id": "订单号",
      "createdAt": "创建时间",
      "originCompanyName": "发货公司",
      "origin": "发货地",
      "destinationCompanyName": "收货公司",
      "destination": "送货地",
      "carrier": "承运商",
      "proNumber": "运单号",
      "poNumber": "订单号",
      "shipperReference": "发货参考号",
      "status": "订单状态",
      "amount": "金额",
      "operations": "操作",
      "charge": "补扣款",
      "refund": "取消",
      "chargeOrder": "订单补扣款",
      "refundOrder": "订单退款",
      "chargeTip": "请输入补扣款(反单)金额",
      "refundTip": "请确认退款操作",
      "chargeAmount": "补扣款金额",
      "amountPlaceholder": "请输入补扣款金额",
      "comment": "备注",
      "chargeCommentPlaceholder": "请输入原因",
      "commentPlaceholder": "备注",
      "balanceAdjustSuccess": "订单补扣款成功",
      "balanceAdjustError": "余额调整失败",
      "orderAdjustError": "订单调整失败",
      "search": {
        "query": "系统/客户订单号/运单号/用户名/地址搜索",
        "status": {
          "all": "所有状态",
          "progress": "进行中",
          "complete": "已完成",
          "canceled": "已取消"
        },
        "startDate": "开始时间",
        "endDate": "结束时间",
        "to": "至",
        "date": {
          "today": "上周",
          "month": "上个月",
          "months": "最近3个月"
        },
        "showType": {
          "all": "显示全部订单",
          "onlyMine": "仅显示我的订单"
        }
      },
      "details": {
        "title": "订单详情",
        "shipmentAlerts": "运输提醒",
        "carrierInfo": "承运人信息",
        "activity": "活动记录",
        "origin": "发货地",
        "destination": "收货地",
        "commodities": "货物信息",
        "pickupDate": "提货日期",
        "estimatedDeliveryDate": "预计送达日期",
        "pickupRequirements": "提货要求",
        "deliveryRequirements": "送货要求",
        "shipmentReferences": "运输参考",
        "pricing": "价格信息",
        "fetchError": "获取订单详情失败",
        "activityDate": "日期",
        "activityStatus": "状态",
        "activityUser": "用户",
        "carrierLabel": "承运商",
        "pickupNumberLabel": "提货编号",
        "proNumberLabel": "运单号",
        "originCompanyNameLabel": "公司名称",
        "originStreetAddressLabel": "街道地址",
        "originContactLabel": "联系人",
        "originPhoneLabel": "电话",
        "originEmailLabel": "邮箱",
        "destinationCompanyNameLabel": "公司名称",
        "destinationStreetAddressLabel": "街道地址",
        "destinationContactLabel": "联系人",
        "destinationPhoneLabel": "电话",
        "destinationEmailLabel": "邮箱",
        "commoditiesHandlingUnits": "处理单元",
        "commoditiesPackaging": "包装",
        "commoditiesPieces": "件数",
        "commoditiesWeight": "重量",
        "commoditiesHazmat": "危险品",
        "commoditiesDescription": "品名",
        "commoditiesDimensions": "尺寸",
        "commoditiesMarkings": "标记",
        "commoditiesNMFC": "NMFC",
        "commoditiesClass": "密度等级",
        "commoditiesTotal": "总计",
        "customerPO": "客户订单号",
        "shipperReference": "发货参考号",
        "serviceLevel": "服务等级",
        "linehaul": "运输费",
        "fuelSurcharge": "燃油附加费",
        "accessorials": "额外服务费",
        "total": "总计",
        "billOfLadingLabel": "提货单",
        "downloadBol": "下载提货单",
        "loadingDetails": "正在加载订单详情...",
        "originCityLabel": "城市",
        "destinationCityLabel": "城市",
        "originZipCode": "邮政编码",
        "destinationZipCode": "邮政编码",
        "poReference": "客户订单号",
        "yes": "是",
        "no": "否",
        "linearFoot": "线性英尺",
        "traceDesc": "描述"
      },
      "list": {
        "title": "订单列表",
        "copyOrderIdSuccess": "已复制系统订单号",
        "copyCustomerReferenceSuccess": "已复制客户订单号"
      },
      "fetchError": "获取订单列表失败",
      "shipmentId": "运单号",
      "userId": "下单用户",
      "orderId": "订单号",
      "poReference": "客户订单号",
      "systemOrderNumber": "系统订单号",
      "copyOrderIdSuccess": "已复制系统订单号",
      "copyCustomerReferenceSuccess": "已复制客户订单号",
      "carrierCode": "物流承接商",
      "providerCode": "服务商",
      "audit": "审单",
      "edit": "编辑",
      "backOrder": "返单",
      "auditStatus": "审核状态"
    },
    "profile": {
      "title": "个人信息",
      "userId": "用户名",
      "balance": "余额",
      "companyName": "公司名称",
      "contactName": "联系人",
      "email": "电子邮件",
      "newEmail": "新邮箱",
      "phone": "电话",
      "bank": "开户银行",
      "bankAccount": "银行账号",
      "address": "公司地址",
      "verificationCode": "验证码",
      "invitationCode": "邀请码",
      "edit": {
        "change": "修改",
        "title": "编辑个人信息",
        "companyNamePlaceholder": "请输入公司名称",
        "contactNamePlaceholder": "请输入联系人姓名",
        "emailPlaceholder": "请输入电子邮件地址",
        "newEmailPlaceholder": "请输入新的邮箱地址",
        "phonePlaceholder": "请输入电话号码",
        "bankPlaceholder": "请输入开户银行",
        "bankAccountPlaceholder": "请输入银行账号",
        "addressPlaceholder": "请输入公司地址",
        "verificationCodePlaceholder": "输入验证码",
        "sendCode": "发送验证码",
        "codeSent": "验证码已发送",
        "sendCodeFailed": "验证码发送失败",
        "emailInvalid": "请输入有效的邮箱地址",
        "verificationCodeRequired": "请输入验证码"
      },
      "transactions": {
        "title": "动账记录",
        "date": "日期",
        "amount": "变动金额",
        "note": "备注",
        "balance": "结余"
      },
      "changePassword": "修改密码",
      "password": {
        "new": "新密码",
        "confirm": "确认密码",
        "newPlaceholder": "请输入新密码",
        "confirmPlaceholder": "请再次输入新密码",
        "required": "请输入密码",
        "tooShort": "密码长度不能少于 8 位",
        "notMatch": "两次输入的密码不一致",
        "changeSuccess": "密码修改成功",
        "needEmail": "请先添加邮箱"
      },
      "userHead": "头像"
    },
    "customers": {
      "inviteTitle": "邀请",
      "title": "我的客户",
      "userGroups": "用户组",
      "userGroup": "用户组",
      "customers": "客户",
      "searchPlaceholder": "搜索客户...",
      "customerId": "客户 ID",
      "companyName": "公司名称",
      "contactName": "联系人",
      "email": "电子邮件",
      "phone": "电话",
      "fromUser": "来自",
      "status": {
        "status": "状态",
        "active": "已启用",
        "inactive": "已禁用"
      },
      "bankName": "开户行",
      "bankAccount": "银行卡号",
      "address": "地址",
      "details": {
        "title": "客户详情",
        "basicInfo": "基本信息",
        "adminSettings": "管理设置",
        "accountNumber": "账号",
        "accountNumberPlaceholder": "请输入账号",
        "currentBalance": "客户余额",
        "commission": "佣金",
        "status": "状态",
        "statusActive": "启用",
        "statusInactive": "禁用",
        "fetchError": "加载客户详情失败",
        "increase": "增加",
        "decrease": "减少",
        "increaseBalance": "增加余额",
        "decreaseBalance": "减少余额",
        "increaseBalanceTip": "请输入该客户要增加的金额",
        "decreaseBalanceTip": "请输入该客户要减少的金额",
        "adjustAmount": "金额",
        "amountPlaceholder": "请输入金额",
        "note": "备注",
        "orderDate": "下单日期",
        "orderDateplaceholder": "请选择下单日期",
        "customerOrderNo": "客户订单号",
        "customerOrderNoPlaceholder": "请输入客户订单号",
        "notePlaceholder": "请输入调整原因",
        "adjust": "修改",
        "adjustCommission": "修改佣金",
        "adjustCommissionTip": "请输入新的佣金比例（0-100%）",
        "commissionPlaceholder": "请输入佣金比例",
        "viewSubOrders": "允许查看子账号订单?",
        "customerOrderList": {
          "orderList": "客户订单列表",
          "shipmentId": "运单号",
          "status": "状态",
          "freightCost": "运费",
          "fuelSurcharge": "燃油费",
          "accessorialFees": "附加费用",
          "totalCost": "总原价",
          "totalSell": "总卖出价",
          "profit": "利润",
          "noOrders": "暂无订单",
          "statusDelivered": "已送达",
          "statusInTransit": "运输中",
          "statusPending": "待处理",
          "statusCancelled": "已取消"
        },
        "advancedSettings": "高级设置",
        "enable": "账号启用",
        "disable": "账号禁用",
        "allowViewOrders": "允许查看订单",
        "disallowViewOrders": "不允许查看订单",
        "balanceAdjust": {
          "title": "余额调整",
          "increase": "增加余额",
          "decrease": "减少余额",
          "amount": "金额",
          "amountPlaceholder": "请输入调整金额",
          "note": "备注",
          "notePlaceholder": "请输入调整原因",
          "success": "余额调整成功",
          "failed": "余额调整失败"
        },
        "insufficientBalance": "您的余额不足",
        "customerInsufficientBalance": "客户余额不足",
        "userGroups": "用户组",
        "userGroup": "用户组",
        "customers": "客户",
        "updatePassword": {
          "title": "修改用户密码",
          "button": "修改用户密码",
          "password": "新密码",
          "passwordPlaceholder": "请输入新密码",
          "confirmPassword": "确认密码",
          "confirmPasswordPlaceholder": "请再次输入新密码",
          "passwordMismatch": "两次输入的密码不一致",
          "success": "密码修改成功",
          "failed": "密码修改失败"
        },
        "deleteUser": {
          "title": "删除用户",
          "button": "删除用户",
          "confirmTitle": "确认删除用户",
          "confirmMessagePrefix": "确定要删除用户",
          "confirmMessageSuffix": "吗？此操作无法撤销。",
          "success": "用户删除成功",
          "failed": "用户删除失败"
        }
      },
      "inviteCode": "邀请码",
      "clickToCopy": "点击复制邀请链接",
      "copied": "已复制！",
      "inviteLinkTitle": "邀请链接",
      "copySuccess": "复制成功！",
      "confirm": "确认",
      "back": "返回上级",
      "level": "客户层级",
      "createTime": "创建时间",
      "subCustomer": "下级客户",
      "orderCount": "订单数",
      "userStatus": "合作状态",
      "edit": "修改客户密码",
      "delete": "删除",
      "confirmDelete": "确认删除该客户吗？",
      "deleteSuccess": "删除成功",
      "deleteFailed": "删除失败"
    },
    "finance": {
      "title": "财务明细",
      "availableBalance": "可用余额",
      "search": {
        "orderNumber": "系统/客户订单号/流水号/用户ID搜索",
        "types": {
          "all": "所有类型",
          "recharge": "充值",
          "deduction": "系统扣款",
          "refund": "退款",
          "extraDebit": "补扣款(返单)",
          "manualDeduction": "人工扣款",
          "deduction2": "扣款"
        },
        "dateRange": {
          "to": "至"
        },
        "searchButton": "搜索",
        "clearButton": "清空",
        "exportButton": "导出"
      },
      "table": {
        "serialNumber": "流水号",
        "systemOrderNumber": "系统订单号",
        "customerOrderNumber": "客户订单号",
        "transactionType": "交易类型",
        "direction": "资金流向",
        "amount": "交易金额",
        "userBalance": "用户余额",
        "createdTime": "创建时间",
        "comments": "备注",
        "copySuccess": "已复制系统订单号",
        "system": "系统",
        "repeatPurchasing": "返单买价"
      },
      "pagination": {
        "total": "共",
        "itemsPerPage": "条/页"
      },
      "fetchError": "获取数据失败",
      "invoice": "发票",
      "invoiceNo": "发票号",
      "amountDue": "应付金额",
      "invoiceDate": "出票日期",
      "billTime": "账期",
      "dueDate": "到期日期",
      "orderNo": "订单号",
      "customer": "客户",
      "serialNo": "序号",
      "serviceItem": "服务项目及说明",
      "quantity": "数量",
      "unitPrice": "单价",
      "amount": "金额",
      "subtotal": "小计",
      "total": "合计",
      "companyName": "贵阳沃亚基信息科技有限公司",
      "companyAddress": "贵州省贵阳市观山湖区长岭街道长岭北路8号",
      "companyAddress2": "美的.林城时代F-02，F-03栋11层1号",
      "buttons": {
        "print": "打印",
        "invoice": "开发票",
        "editInvoice": "编辑"
      },
      "placeholders": {
        "invoiceNo": "请输入发票号",
        "invoiceDate": "请选择出票日期",
        "billTime": "请输入账期",
        "dueDate": "请选择到期日期",
        "invoiceData": "请先获取发票数据"
      },
      "saveConfirm": "保存并打印",
      "updataConfirm": "更新并打印"
    },
    "list": {
      "emptyText": "暂无数据",
      "loadingText": "加载中..."
    },
    "menu": {
      "list": {
        "title": "菜单管理",
        "columns": {
          "menuName": "菜单名称",
          "icon": "图标",
          "menuType": "菜单类型",
          "menuSort": "排序值",
          "noTagsView": "是否隐藏",
          "createTime": "创建时间",
          "actions": {
            "addSubmenu": "新增菜单",
            "editMenu": "编辑",
            "del": "删除",
            "bindMenu": "绑定菜单",
            "bindUser": "绑定用户",
            "select": "选择"
          },
          "menuPath": "路由地址",
          "component": "组件路径",
          "noCache": "禁用缓存"
        }
      },
      "form": {
        "menuName": "菜单名称",
        "menuExtend": "路由Name",
        "menuExtendPlaceholder": "请输入路由Name,必须唯一",
        "component": "组件路径",
        "componentPlaceholder": "请输入组件路径",
        "menuPathPlaceholder": "请输入路由路径",
        "menuPath": "路由路径",
        "menuNamePlaceholder": "请输入菜单名称",
        "menuName4": "按钮名称",
        "parentIdPlaceholder": "请选择上级菜单",
        "parentId": "上级",
        "menuType": "菜单类型",
        "externalLink": "路由重定向",
        "externalLinkplaceholder": "请输入默认跳转地址",
        "icon": "菜单图标",
        "iconPlaceholder": "请选择菜单图标",
        "activeMenu": "激活菜单",
        "activeMenuPlaceholder": "请输入需要激活的菜单",
        "menuSort": "排序",
        "menuSortPlaceholder": "越小越靠前，不填写默认系统生成",
        "menuExtend4": "按钮权限",
        "menuExtend4Placeholder": "请输入按钮权限",
        "apiUrl": "接口URL",
        "apiUrlplaceholder": "请填写当前菜单或按钮需要访问的后端接口uri，多个用英文字符,分割。",
        "noTagsView": {
          "0": "否",
          "1": "是"
        }
      },
      "updateSuccess": "更新成功",
      "createSuccess": "新增成功",
      "deleteSuccess": "菜单删除成功",
      "deleteError": "菜单删除失败"
    },
    "role": {
      "list": {
        "columns": {
          "actions": {
            "addSubmenu": "新增角色"
          },
          "roleStatus": {
            "0": "禁用",
            "1": "启用",
            "label": "状态"
          }
        }
      },
      "form": {
        "menuType": "角色类型",
        "roleName": "角色名称",
        "roleNamePlaceholder": "请输入角色名称",
        "roleDesc": "角色描述",
        "roleDescPlaceholder": "请输入角色描述"
      },
      "bindUser": {
        "userName": "用户名",
        "userEmail": "邮箱",
        "userPhone": "手机号",
        "success": "绑定成功",
        "error": "绑定用户失败"
      }
    },
    "order": {
      "form": {
        "auditDesc": "审核描述",
        "auditDescPlaceholder": "请输入审核描述",
        "repeatPurchasing": "返单买价",
        "repeatPurchasingPlaceholder": "请输入返单买价",
        "repeatSelling": "返单卖价",
        "repeatSellingPlaceholder": "请输入返单卖价",
        "totalOrderProfit": "总利润",
        " purchasePrice": "买价",
        "sellingPrice": "卖价",
        "repeatSelling2": "返单金额"
      },
      "auditSuccess": "审核成功",
      "btns": {
        "1": "审核通过",
        "2": "驳回订单"
      },
      "auditError": "审核失败",
      "backOrderSuccess": "返单成功",
      "backOrderError": "返单失败"
    },
    "invoice": {
      "table": {
        "invoiceNo": "发票编号",
        "orderNo": "系统订单号",
        "companyAddress": "客户公司地址",
        "companyName": "客户公司名称",
        "creatorName": "开票人姓名"
      },
      "search": {
        "orderNoPlaceholder": "输入关联系统订单号",
        "placeholder": "请输入",
        "keyWords": "关键字"
      }
    }
  },
  "countryName": {
    "USA": "美国",
    "Canada": "加拿大",
    "China": "中国"
  },
  "menuType": {
    "menu": "菜单",
    "btn": "按钮",
    "unknown": "未知"
  },
  "roleType": {
    "normal": "普通角色",
    "customerService": "客服角色",
    "finance": "财务角色",
    "director": "主管角色"
  },
  "quoteHistory": {
    "searchPlaceholder": "请输入关键字(邮编/公司名称/城市/州/运单类型)查询",
    "userNamePlaceholder": "请输入用户名"
  },
  "orderStatus": {
    "Editing":"已编辑",
    "pending": "待处理",
    "quoting": "报价中",
    "confirmed": "已确认",
    "prepared": "备货中",
    "sentToCarrier": "已发送至承运商",
    "dispatched": "已发货",
    "inTransit": "运输中",
    "outForDelivery": "派送中",
    "delivered": "已送达",
    "completed": "已完成",
    "cancelled": "已取消",
    "unknown": "未知状态"
  },
  "auditStatus": {
    "awaiting": "待审",
    "passed": "通过",
    "denied": "驳回"
  },
  "orderType": {
    "order": "下单",
    "edit": "编辑",
    "reduction": "补扣",
    "refund": "取消",
    "backOrder": "返单"
  },
  "role": {
    "bindUser": {
      "candidateList": "备选列表",
      "placeholder": "请输入关键字",
      "selectedList": "已选列表"
    }
  }
}
